import React, { Component, Fragment } from 'react';
import ViewingDay from './viewing_day';
import ViewingTime from './viewing_time';
import HttpRequestor from '../utils/http_requestor';
import LoginOrSignupForm from './login_or_signup_form';
import ConfirmTimeslot from './confirm_timeslot';
import ResendConfirmation from './resend_confirmation';
import SavingDots from '../shared/saving_dots';
import I18n from '~/utils/translations';
import UserTypeInput from '~/components/book_viewing/user_type_input';
import _isEmpty from 'lodash/isEmpty';

export default class ViewingSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewingTimes: [],
      viewingTimesLoaded: false,
      selectedDay: null,
      selectedTime: null,
      selectedUserType: null,
      submitting: false,
      user: {},
    };
  }

  componentDidMount() {
    this.getViewingTimes();
    this.props.onAnimationCompleted();
  }

  componentDidUpdate() {
    if (this.props.animated) {
      this.pulseInnerSection();
    }
  }

  selectTime = (e, time) => {
    this.setState(
      {
        selectedTime: time,
      },
      () => {
        this.props.timeslotSelected && this.props.timeslotSelected(time);
      }
    );
  };

  renderTimes() {
    const times = this.state.selectedDay.times.map((time) => {
      const timeSelected = this.state.selectedTime && this.state.selectedTime.datetime == time.datetime;

      return (
        <ViewingTime
          key={`time-${time.utcTimestamp}`}
          time={time}
          onClick={(e) => this.selectTime(e, time)}
          selected={timeSelected}
        />
      );
    });

    return (
      <div id="time-choices" className="time-choices book-viewing-section">
        <div className="book-viewing-section__inner">
          <div className="time-group" id={`timegroup_${this.state.selectedDay.date}`}>
            <h3 className="center book-a-viewing__step-title">Choose a time</h3>
            <div className="times">{times}</div>
          </div>
        </div>
      </div>
    );
  }

  selectDay = (e, day) => {
    this.setState({
      selectedDay: day,
    });
  };

  formatDaysToDisplay = (days) => {
    const nextAvailableDay = () => {
      for (let i = 0; i < days.length; i++) {
        if (!days[i].props.day.isDisabled) return i;
      }
    };

    if (days.length > 6) {
      days.splice(0, nextAvailableDay());
      const daysToShow = days.splice(0, 6);
      return daysToShow;
    }
    return days;
  };

  renderDays() {
    const days = this.state.viewingTimes.map((day) => {
      const daySelected = this.state.selectedDay && this.state.selectedDay.date == day.date;
      return (
        <ViewingDay key={`day-${day.date}`} day={day} onClick={(e) => this.selectDay(e, day)} selected={daySelected} />
      );
    });

    const formattedDays = this.formatDaysToDisplay(days);

    return (
      <div id="day-choices" className="day-choices book-viewing-section">
        <div className="book-viewing-section__inner">
          <h3 className="center book-a-viewing__step-title">{I18n.t('viewings.choose_a_day')}</h3>
          {formattedDays.length > 0 ? (
            <div className="days">{formattedDays}</div>
          ) : (
            <div className="days">{I18n.t('viewings.no_availability')}</div>
          )}
        </div>
      </div>
    );
  }

  pulseInnerSection = () => {
    const tl = new TimelineLite();
    const viewingSectionInner = document.querySelector('.book-viewing-section__inner');

    tl.to(viewingSectionInner, 0.5, {
      transform: 'scale(1.1)',
    });

    tl.to(viewingSectionInner, 0.5, {
      transform: 'scale(1)',
    });

    this.props.onAnimationCompleted();
  };

  onInformationChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  bookViewingSlot = (params) => {
    const defaultParams = {
      property_id: this.props.property.id,
      listing_id: this.props.listing,
      viewing_event_id: null,
      start_time: this.state.selectedTime.datetime,
    };

    if (this.state.selectedUserType) {
      defaultParams.user_type = this.state.selectedUserType;
    }

    const requestParams = Object.assign({}, defaultParams, params);

    this._submit(requestParams);
  };

  _submit = (params) => {
    this.setState({ submitting: true });
    const requestor = new HttpRequestor();
    requestor
      .call(`/homes/${this.props.property.id}/viewings`, 'POST', {
        data: {
          type: 'viewing',
          attributes: params,
        },
      })
      .then(this._submitSuccess)
      .catch(this._submitError);
  };

  _submitSuccess = (response) => {
    this.setState({ submitted: true });
    track_event('home-viewing-flow', 'viewing-submission', 'success', null, 'CompleteRegistration');
    track_viewing(response.id);
    this.props.handleViewingBooked(this.state.selectedTime, response.id);
  };

  _submitError = (response) => {
    this.setState({
      submitting: false,
      submitError: response.error ? response.error : 'Something went wrong, please try again',
    });
    track_event('home-viewing-flow', 'viewing-submission', 'error');
  };

  userIsGuest() {
    const user = this.state;
    return user.user_exists && !user.user_registered;
  }

  renderLastSection() {
    if (this.props.submitted || (this.props.userHasSession && !this.userIsGuest())) {
      return (
        <ConfirmTimeslot
          propertyAddress={this.userIsGuest() ? this.props.property.fullAddress : this.props.property.privatisedAddress}
          property={this.props.property}
          datetime={this.state.selectedTime && this.state.selectedTime.timeLabel}
          loading={this.state.submitting}
          submitted={this.state.submitted}
          submitError={this.state.submitError}
          onConfirm={() => this.bookViewingSlot()}
          viewingEvent={false}
        >
          {this.showUserTypeSelect && (
            <div className="about-you__inner about-you__inner--no-spacing">
              <UserTypeInput value={this.state.selectedUserType} onChange={this.onUserTypeChange} />
            </div>
          )}
        </ConfirmTimeslot>
      );
    }
  }

  renderLastSectionButtons() {
    if (this.state.user.user_exists && !this.state.user.user_registered) {
      // Resend confirmation
      if (this.state.user.upcoming_viewing_for_property) {
        return <ResendConfirmation propertyId={this.props.property.id} userEmail={this.state.user.email} />;
      }
    }
  }

  onUserTypeChange = (option) => {
    this.setState({ selectedUserType: option.value });
  };

  onUserChanged = (user) => {
    const state = { user };

    this.setState(state);
  };

  prequalRequired() {
    const { property, latestCustomPreQualificationAnswers, preQualificationQuestions, isFullUser } = this.props;

    if (!property.preQualificationEnabled) {
      return false;
    }

    const latestCustomAnswersEmpty = _isEmpty(latestCustomPreQualificationAnswers);

    if (latestCustomAnswersEmpty) {
      return true;
    }

    const customPreQualAnswersIncomplete = preQualificationQuestions.some((requiredQuestion) => {
      if (requiredQuestion.required) {
        const answer = latestCustomPreQualificationAnswers.find(
          (answer) => answer && answer.question.key === requiredQuestion.key
        );
        return !answer;
      }
      return false;
    });

    return !isFullUser && customPreQualAnswersIncomplete;
  }

  render() {
    const prequalRequired = this.prequalRequired();
    const showLoginForm = prequalRequired || !(this.props.submitted || this.props.userHasSession);

    const showPreQualDecline = this.props.property.preQualificationEnabled && !this.props.preQualPassed;

    return (
      <section className="book-a-viewing">
        {showLoginForm && (
          <Fragment>
            <LoginOrSignupForm
              registerUrl="/users/viewing-register"
              property={this.props.property}
              listing={this.props.listing}
              doorbellHost={this.props.doorbellHost}
              buttonText={I18n.t('login_or_signup.new_user.button')}
              onUserChanged={this.onUserChanged}
              onSignIn={this.onSignIn}
              signInRedirect={window.location.href}
              trackCategory="home-viewing-flow"
              trackAction="viewing-submission"
              trackLabel="success"
              facebookEvent="CompleteRegistration"
              renderLastSectionButtons={this.renderLastSectionButtons()}
              defaultEmail={this.props.email}
              preQualificationQuestions={this.props.preQualificationQuestions}
              customPreQualificationAnswers={this.props.latestCustomPreQualificationAnswers}
              signedIn={this.props.userHasSession && !this.userIsGuest()}
            />
          </Fragment>
        )}

        {!showLoginForm && (
          <Fragment>
            {showPreQualDecline && (
              <Fragment>
                <p>{I18n.t('viewings.pre_qual_result.headline')}</p>
                <br />
                <p>
                  {I18n.t('viewings.pre_qual_result.fail.line1', {
                    property: this.props.property.headline,
                  })}
                </p>
                <p>{I18n.t('viewings.pre_qual_result.fail.line2')}</p>
              </Fragment>
            )}

            {!showPreQualDecline && (
              <Fragment>
                {this.state.viewingTimesLoaded && this.renderViewingOptions()}
                {!this.state.viewingTimesLoaded && <SavingDots className="book-a-viewing__loading" />}
              </Fragment>
            )}
          </Fragment>
        )}
      </section>
    );
  }

  renderViewingOptions() {
    const hasViewingAvailabilty = this.state.viewingTimes.length > 0;

    return (
      <section className="book-a-viewing__choose block-new day-time">
        <p>{I18n.t('viewings.pre_qual_result.headline')} </p>
        <br />

        {!hasViewingAvailabilty && <p>{I18n.t('viewings.in_touch_no_availability')}</p>}

        {hasViewingAvailabilty && (
          <div className="content">
            <p>{I18n.t('viewings.pre_qual_result.pass')}</p>
            {this.renderDays()}
            {this.state.selectedDay && this.state.selectedDay.times && this.renderTimes()}
            {this.state.selectedTime && this.state.selectedTime.timeLabel && this.renderLastSection()}

            {this.props.showOtherOptions && (
              <div className="book-viewing-section">
                <a
                  className="book-a-viewing__viewing-events"
                  href="#viewings"
                  data-trigger="book-viewing-event"
                  data-ga-category="home-viewing-flow"
                  data-ga-action="switch-to-viewing-events"
                  onClick={this.props.showOtherOptions}
                >
                  {I18n.t('viewings.link_to_viewing_events')} &rsaquo;
                </a>
              </div>
            )}
          </div>
        )}
      </section>
    );
  }

  getViewingTimes = () => {
    const requestor = new HttpRequestor();
    requestor.call(this.viewingTimesUrl, 'GET').then((viewingTimes) => {
      const selectedDayTime = this.getDefaultSelectedDayTime(viewingTimes);
      this.setState({ ...selectedDayTime, viewingTimes, viewingTimesLoaded: true });
    });
  };

  getDefaultSelectedDayTime = (viewingTimes) => {
    let result = {
      selectedDay: null,
      selectedTime: null,
    };

    if (this.props.selectedDay && this.props.selectedTime) {
      const selectedDay = viewingTimes.find((viewing_day) => viewing_day.date == this.props.selectedDay);
      const selectedTime = selectedDay.times.find((viewing_time) => viewing_time.datetime == this.props.selectedTime);
      result.selectedDay = selectedDay;
      result.selectedTime = selectedTime;
    }

    return result;
  };

  get viewingTimesUrl() {
    return `/homes/${this.props.property.id}/viewing_times`;
  }

  get showUserTypeSelect() {
    return this.props.property.brokers_enabled;
  }

  onSignIn = () => {
    const { selectedTime, selectedDay, selectedSlot } = this.state;

    const selected = {
      time: (selectedTime && selectedTime.datetime) || null,
      day: (selectedDay && selectedDay.date) || null,
      slot: (selectedSlot && selectedSlot.id) || null,
    };

    sessionStorage.setItem('selectedTime', JSON.stringify(selected));
  };
}
